export class ApiError {
	status = 0;
	statusText = null;
	errorMessage = null;
	data = null;

	/**
	 *
	 * @param {import("axios").AxiosError['response']} errorResponse
	 */
	constructor(errorResponse) {
		this.status = errorResponse.status;
		this.statusText = errorResponse.statusText;
		// TODO: should be able to handle errorResponse.data.errors as well not only errorResponse.data.error
		//       see Toast.vue::handleError()
		this.errorMessage = errorResponse.data.error;
		this.data = errorResponse.data;
	}
}
